let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];

class TunnelService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
    }

    getCountriesBilling() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.countries,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getStatesBilling(countryId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.states + countryId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getCitiesBilling(stateId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.cities + stateId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPayMethods() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.payMethods,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateDespachoPedido(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateDespachoPedido,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveCartTunnelData(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.saveCartTunnelData,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveOrder(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.saveOrder,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


}

TunnelService.$inject = inject;

export default TunnelService;



// WEBPACK FOOTER //
// ./www/components/tunnel/tunnel.service.js